import { TeamMembershipSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const TEAM_MEMBER_TABLE = '"public"."teamMemberships"'

export const TeamMembershipConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: TEAM_MEMBER_TABLE,
  partitionKey: 'team_id',
  key: 'id',
  apiEndpoint: '/api/team/[team_id]/members',
  where: {},
  schema: TeamMembershipSchema,
}
